import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { LocalStorage } from 'ngx-store';

@Injectable()
export class TbwService {
    api: string = environment.apiUrl;
    @LocalStorage('loggedUser') loggedUser: any;
    @LocalStorage('userData') userData: any;

    constructor(private http: HttpClient) { }


    async getTest(type: string): Promise<any> {
        const headers = new HttpHeaders({ 'Content-Type': 'application/json', Authorization: 'Bearer ' + this.loggedUser.access_token });
        return await this.http
            .get(this.api + `/tbw/tbw_test?type=${type}`, { headers, observe: 'response' })
            .toPromise();
    }

    async save(body): Promise<any> {
        const headers = new HttpHeaders({ 'Content-Type': 'application/json', Authorization: 'Bearer ' + this.loggedUser.access_token });
        return await this.http
            .post(this.api + `/tbw/trial`, body, { headers, observe: 'response' })
            .toPromise();
    }

    async setDemo(body): Promise<any> {
        const headers = new HttpHeaders({ 'Content-Type': 'application/json', Authorization: 'Bearer ' + this.loggedUser.access_token });
        return await this.http
            .post(this.api + `/tbw/set_demo`, body, { headers, observe: 'response' })
            .toPromise();
    }

    async check_demo(): Promise<any> {
        const headers = new HttpHeaders({ 'Content-Type': 'application/json', Authorization: 'Bearer ' + this.loggedUser.access_token });
        return await this.http
            .get(this.api + `/tbw/check_demo`, { headers, observe: 'response' }).toPromise();
    }

    async check_exp(): Promise<any> {
        const headers = new HttpHeaders({ 'Content-Type': 'application/json', Authorization: 'Bearer ' + this.loggedUser.access_token });
        return await this.http
            .get(this.api + `/check_tbw`, { headers, observe: 'response' }).toPromise();
    }
}
